import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppModule } from './app.module';
import { CmsAuthInterceptor } from './common/_services/connect/cms.service';
import { FeatureFlagService } from './common/_services/featureFlag.service';
import { ThemeConfig } from '../assets/data/enum/themeConfig';
import { providePostHogErrorHandler } from './common/_services/posthog-error-handler';
import { providePrimeNGConfig } from './config/primeng.config';

function initFeatureFlagsFactory() {
  const ff = inject(FeatureFlagService);
  const theme = ThemeConfig;

  return async () => {
    const context = {
      key: 'all-users',
      kind: 'user',
      custom: { saas: theme.brand },
    };
    await ff.initialize(context); // Promise<void>
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule, AppModule),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: CmsAuthInterceptor, multi: true },
    providePrimeNGConfig(),
    {
      provide: APP_INITIALIZER,
      useFactory: initFeatureFlagsFactory,
      multi: true,
    },
    providePostHogErrorHandler(),
  ],
};
